import { MDBCol } from "mdbreact";
import React, { Component } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import Notiflix from "notiflix";
import PostApiCall from "../../Api";

import "react-confirm-alert/src/react-confirm-alert.css";

import "react-responsive-modal/styles.css";

import Searchicon from '../../assets/images/dashboardimages/search.png';


import { confirmAlert } from "react-confirm-alert";
import { MdDeleteForever } from "react-icons/md";
import Saveicon from '../../assets/images/dashboardimages/filesave.png';
import Editicon from '../../assets/images/dashboardimages/pencil.png';

const ImgUpload = ({ onChange, src }) => (
  <label htmlFor="photo-upload" className="custom-file-upload fas" style={{ marginBottom: '5px' }}>
    <div className="img-wrap brandimages img-upload">
      <img
        for="photo-upload"
        src={src}
        style={{ width: "100%", height: "100%", borderRadius: "5%" }}
      />
    </div>
    <input accept="image/*" id="photo-upload" type="file" onChange={onChange} />
  </label>
);

class StickerShapeMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      searchInput: "",
      stickerShapeData: [],
      ViewClick: "true",
      open: false,
      imagePreviewUrl: 'https://icons.iconarchive.com/icons/pelfusion/flat-folder/256/Upload-Folder-icon.png',
      ImageApiUrl: JSON.parse(localStorage.getItem("ClientDetails"))[0].fld_apiaddress + "AddImage",
      Status: "Yes",
      shapeName: "",
      sequence: null,
      cuttingCost: null,
      cuttingCostBasePrice: null,
      originalImage: null,
      outputFileName: null,
      openedit: false,
      stickerShapeId: null,
    };
  }

  componentDidMount() {
    Notiflix.Loading.Init({
      svgColor: "#777f80",
      // ...
    });

    // Fetch sticker shape data from the API
    PostApiCall.postRequest(
      {
        WhereClause: "",
      },
      "GetStickerShapeMaster"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status === 200 || result.status === 201) {
          this.setState({
            stickerShapeData: obj.data.filter((item) => item.fld_status !== "Deleted"),
          });
          Notiflix.Loading.Remove();
        }
      })
    );
  }
  onAddImage() {
    const form1 = new FormData();

    // console.log(this.state.originalImage)

    form1.append("file", this.state.originalImage);
    form1.append("foldername", "ShapeImages");
    form1.append("filename", this.state.stickerShapeId + "-" + this.state.outputFileName);

    fetch(this.state.ImageApiUrl, {
      method: "POST",
      body: form1,
    }).then((obj) => {
      PostApiCall.postRequest(
        {
          WhereClause: "",
        },
        "GetStickerShapeMaster"
      ).then((result) =>
        result.json().then((obj) => {
          if (result.status === 200 || result.status === 201) {
            this.setState({
              stickerShapeData: obj.data.filter((item) => item.fld_status !== "Deleted"),
              stickerShapeId: null,
              shapeName: null,
              imagePreviewUrl: 'https://icons.iconarchive.com/icons/pelfusion/flat-folder/256/Upload-Folder-icon.png',
              Status: "Yes"
            });
            Notiflix.Loading.Remove();
          }
        })
      );
    })
  }

  // name is mandatory
  onSaveData() {
    const foundItem = this.state.stickerShapeData.find(item => item.fld_sequence == this.state.sequence || String(item.fld_sequence) == this.state.sequence);
    // console.log(this.state.sequence, !foundItem)
    if (this.state.sequence || !foundItem) {
      if (this.state.fld_shape_name !== "") {
        this.onPost();
      } else {
        Notiflix.Notify.Failure("Please enter sticker shape name");
      }
    } else {
      Notiflix.Notify.Failure("Please enter a unique sequence");
    }
  }

  onPost = () => {
    Notiflix.Loading.Dots("Please wait...");

    var login = localStorage.getItem("LoginDetail");
    var details = JSON.parse(login);

    PostApiCall.postRequest(
      {
        fld_id: this.state.stickerShapeId, // ID with response
        shapename: this.state.shapeName,
        status: this.state.Status,
        shapeImage: this.state.outputFileName != 'NoChange' ? JSON.parse(localStorage.getItem("ClientDetails"))[0].fld_image_url_path + "/ShapeImages/" +
          this.state.stickerShapeId + "-" + this.state.outputFileName : this.state.imagePreviewUrl,
        sequence: this.state.sequence,
        cuttingCost: this.state.cuttingCost,
        cuttingCostBasePrice: this.state.cuttingCostBasePrice ? this.state.cuttingCostBasePrice : 0.00
      },
      "AddShapeMaster"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status === 200 || result.status === 201) {
          Notiflix.Loading.Remove();
          Notiflix.Notify.Success("New sticker shape successfully added");
          this.onAddImage();
          this.componentDidMount();
          this.setState({
            stickerShapeId: null,
            shapeName: null,
            Status: null,
            sequence: null,
            cuttingCost: null,
            cuttingCostBasePrice: null
          })
        } else {
          Notiflix.Loading.Remove();
          Notiflix.Notify.Failure(
            "Something went wrong, please try again later"
          );
        }
      })
    );
  };

  handleInputChange = (e) => {
    this.setState({
      fld_shape_name: e.target.value,
    });
  };

  searchBarHandler = (e) => {
    this.setState({
      searchInput: e.target.value,
    });
  };

  photoUpload = (e) => {
    e.preventDefault();
    const imageFile = e.target.files[0];
    this.setState({
      imagePreviewUrl: URL.createObjectURL(imageFile),
      originalImage: imageFile,
      outputFileName: imageFile.name,
      uploadImage: true
    });
  };


  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}

            <div className="row">
              <div className="col-md-6">

                <div>
                  <ul class="breadcrumbs">
                    <li><a href="https://store.bechofy.in/">store.bechofy.in</a></li>
                    <li>Master Management</li>
                    <li>Sticker Shape</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                {/* <img src={GtLogo} alt="company logo" className="img-responsive companyLogo"></img> */}

              </div>


            </div>
            <Row>
              <Col xl="12">
                <Card className="pagebackground" id="upload-card">


                  <Card >
                    <div className="Bechofy-bg-soft-pink" style={{ height: '60px' }}>
                      <div className="row my-1">
                        <div className="col-4">
                          <div className="form-group">
                            <h4 className="FilterCard" style={{ marginTop: '10px' }}>Sticker Shapes</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <CardBody className="pt-0">
                      <Row>


                        <MDBCol md="12" style={{ marginBottom: "15px", marginTop: '15px' }} >
                          <div class="input-group mb-3" >


                            <div class="input-group-prepend">
                              <span class="input-group-text" id="basic-addon1">
                                <span className=""><img src={Searchicon} alt="block user" className="btnicons"></img></span></span>
                            </div>
                            <input type="text" class="form-control" placeholder="Type the search phrase you wish to search within the grid" aria-label="Search" aria-describedby="basic-addon1"
                              onChange={(e) => this.seachBarHandler(e)}
                              value={this.state.searchInput}

                            />
                          </div>
                        </MDBCol>

                        <Col md="12">

                          {this.state.stickerShapeData.length !== 0 ?
                            <Card >

                              <CardBody className="pt-0">
                                <Row>
                                  <Col xs="4">
                                    <CardBody className="categoryCard">

                                      <Row className="card-row">
                                        <Col sm="6">
                                          <div className="imagecard">
                                            <div className="form-group ">
                                              <label for="sw-arrows-first-name">
                                                Upload Sticker Shape(1024*1024 px)
                                                <span className="mandatory">*</span>
                                              </label>
                                              <div class="div1">
                                                <ImgUpload
                                                  onChange={this.photoUpload}
                                                  src={this.state.imagePreviewUrl}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          {/* <hr style={{border:'1px solid #fff'}}/> */}
                                        </Col>
                                        <Col sm="6">
                                          <div className="row">
                                            <h5>Add New Shape</h5>
                                            <div className="col-12">
                                              <label class="my-1 mr-2">Shape Name *</label>

                                              <input
                                                className="form-control"
                                                name="name"
                                                type="text"
                                                placeholder="Enter Shape Name"
                                                value={this.state.shapeName}
                                                onChange={(text) => {
                                                  this.setState({
                                                    shapeName: text.target.value,
                                                  });
                                                }}
                                              />
                                            </div>
                                            <div className="col-12">
                                              <label class="my-1 mr-2">Sequence *</label>

                                              <input
                                                className="form-control"
                                                name="name"
                                                type="text"
                                                placeholder="Seq"
                                                value={this.state.sequence}
                                                onChange={(text) => {
                                                  this.setState({
                                                    sequence: text.target.value,
                                                  });
                                                }}
                                              />
                                            </div>
                                            <div className="col-12">
                                              <label class="my-1 mr-2">Base Cutting Cost</label>

                                              <input
                                                className="form-control"
                                                name="name"
                                                type="text"
                                                placeholder=""
                                                value={this.state.cuttingCostBasePrice}
                                                onChange={(text) => {
                                                  this.setState({
                                                    cuttingCostBasePrice: text.target.value,
                                                  });
                                                }}
                                              />
                                            </div>
                                            <div className="col-12">
                                              <label class="my-1 mr-2">Cutting Cost</label>

                                              <input
                                                className="form-control"
                                                name="name"
                                                type="text"
                                                placeholder="1 sq.cm cost"
                                                value={this.state.cuttingCost}
                                                onChange={(text) => {
                                                  this.setState({
                                                    cuttingCost: text.target.value,
                                                  });
                                                }}
                                              />
                                            </div>
                                            <div className="col-12" style={{ marginTop: '10px' }}>
                                              <div className="form-group">
                                                <label for="CategoryName">
                                                  Status
                                                  <span className="mandatory">*</span>
                                                </label>
                                                <br />
                                                <label class="radio-inline">
                                                  <input
                                                    type="radio"
                                                    name="optradio"
                                                    //  disabled={!this.state.IsVisible}
                                                    checked={
                                                      this.state.Status == "Yes"
                                                        ? true
                                                        : false
                                                    }

                                                    onChange={() => {
                                                      this.setState({
                                                        Status: "Yes",
                                                      });
                                                    }}
                                                  />{" "}
                                                  Active
                                                </label>
                                                <label
                                                  class="radio-inline"
                                                  style={{ marginLeft: "10px" }}
                                                >
                                                  <input
                                                    type="radio"
                                                    name="optradio"
                                                    //  disabled={!this.state.IsVisible}
                                                    checked={
                                                      this.state.Status == "No"
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={() => {
                                                      this.setState({
                                                        Status: "No",
                                                      });
                                                    }}
                                                  />{" "}
                                                  Inactive
                                                </label>
                                              </div>
                                            </div>

                                          </div>
                                        </Col>
                                        <hr />
                                      </Row>
                                      <Row>
                                        <Col sm="6">
                                        </Col>
                                        <Col sm="6">

                                          <a
                                            onClick={this.onSaveData.bind(this)}
                                            className="btn Bechofy-btn waves-effect waves-light btn-sm float-right"
                                            style={{ marginTop: "5px", color: "white" }}
                                          >
                                            <span className=""><img src={Saveicon} alt="block user" className="btnicons" style={{ marginRight: '5px' }}></img> </span>

                                            Save
                                          </a>
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  </Col>


                                  {/* ======Brand List */}
                                  {this.state.stickerShapeData.filter((data) => {
                                    if (this.state.searchInput == "") {
                                      return data;
                                    }
                                    if (
                                      this.state.searchInput !== "" &&
                                      (data.fld_shapeName
                                        .toLowerCase()
                                        .includes(this.state.searchInput.toLowerCase()) ||

                                        `${data.fld_status
                                          ? data.fld_status.toLowerCase()
                                          : ""
                                          }`.includes(this.state.searchInput.toLowerCase()))
                                    ) {
                                      return data;
                                    }
                                  }).map((data, i) => (
                                    <Col xs="4">
                                      <CardBody className="categoryCard">

                                        <Row className="card-row">
                                          <Col sm="5" style={{ marginTop: '15px' }}>
                                            <div className="imagecard">
                                              <div className="form-group custom-file-upload fas">

                                                <div class="div1 img-wrap brandimages">
                                                  <img
                                                    src={data.fld_image}
                                                    style={{ width: "100%", height: "100%", borderRadius: "5%" }}
                                                    alt=""
                                                  />
                                                </div>

                                              </div>
                                            </div>
                                            {/* <hr style={{border:'1px solid #fff'}}/> */}
                                          </Col>
                                          <Col sm="7">
                                            <div className="row">
                                              <div className="col-12" style={{ marginTop: '10px' }}>
                                                <p>
                                                  <b>Name</b> -{" "}
                                                  <span>
                                                    {data.fld_shape_name}
                                                  </span>
                                                </p>

                                              </div>
                                              <div className="col-12" style={{ marginTop: '10px' }}>
                                                <p>
                                                  <b>Cutting Cost Base Price </b> -{" "}
                                                  <span>
                                                    ₹ {data.fld_cutting_base_price}
                                                  </span>
                                                </p>

                                              </div>
                                              <div className="col-12" style={{ marginTop: '10px' }}>
                                                <p>
                                                  <b>Cutting Cost </b> -{" "}
                                                  <span>
                                                    ₹ {data.fld_cutting_cost}
                                                  </span>
                                                </p>

                                              </div>
                                              <div className="col-12" style={{ marginTop: '10px' }}>
                                                <p>
                                                  <b>Sequence</b> -{" "}
                                                  <span>
                                                    {data.fld_sequence}
                                                  </span>
                                                </p>

                                              </div>

                                            </div>
                                          </Col>

                                          <hr />
                                        </Row>
                                        <Row>
                                          <Col sm="4" className="BrandStatus">
                                            <p >
                                              <b>Status</b> -{" "}
                                              <span
                                                style={{
                                                  color:
                                                    data.fld_status == "Active" || data.fld_status == "Yes"
                                                      ? "green"
                                                      : "red",
                                                }}
                                              >
                                                {data.fld_status}
                                              </span>
                                            </p>
                                          </Col>
                                          <Col sm="8" className="d-flex justify-content-end align-items-center" style={{ gap: '10px' }}>
                                            <a
                                              onClick={() => {
                                                confirmAlert({
                                                  title: "Confirm to Delete",
                                                  message:
                                                    "Are you sure you want to delete the material?",
                                                  buttons: [
                                                    {
                                                      label: "Yes",
                                                      onClick: () => {
                                                        Notiflix.Loading.Dots("");

                                                        PostApiCall.postRequest(
                                                          {
                                                            fld_id: data.fld_id,
                                                            shapename: data.fld_shape_name,
                                                            status: "Deleted",
                                                            shapeImage: data.fld_image,
                                                            sequence: data.fld_sequence,
                                                            cuttingCost: data.fld_cutting_cost,
                                                            cuttingCostBasePrice: data?.fld_cutting_base_price ? data?.fld_cutting_base_price : 0.00
                                                          },
                                                          "AddShapeMaster"
                                                        ).then((result) =>
                                                          result.json().then((obj) => {
                                                            if (result.status === 200 || result.status === 201) {
                                                              Notiflix.Loading.Remove();
                                                              Notiflix.Notify.Success(" Sticker shape successfully deleted");
                                                              this.componentDidMount();
                                                              this.setState({
                                                                stickerShapeId: null,
                                                                shapeName: null,
                                                                Status: null,
                                                                sequence: null,
                                                                cuttingCost: null,
                                                                cuttingCostBasePrice: null
                                                              })
                                                            } else {
                                                              Notiflix.Loading.Remove();
                                                              Notiflix.Notify.Failure(
                                                                "Something went wrong, please try again later"
                                                              );
                                                            }
                                                          })
                                                        );
                                                      },
                                                    },
                                                    {
                                                      label: "No",
                                                      // onClick: () => alert('Click No')
                                                    },
                                                  ],
                                                });
                                                // postapi



                                              }}
                                              className="btn Bechofy-btn waves-effect waves-light btn-sm float-righ"
                                              style={{ marginTop: "10px", color: "white" }}
                                            >
                                              {/* <span className=""><img src={editicon} alt="block user" className="btnicons" style={{ marginRight: '5px' }}></img> </span> */}

                                              <MdDeleteForever style={{ fontSize: "20px" }} />
                                            </a>
                                            {/* </Col> */}
                                            {/* <Col sm="8" className="d-flex justify-content-end align-items-center" style={{ gap: '10px' }}> */}
                                            <span className="d-block">
                                              <a
                                                onClick={() => {
                                                  this.setState({
                                                    stickerShapeId: data.fld_id,
                                                    shapeName: data.fld_shape_name,
                                                    Status: data.fld_status,
                                                    sequence: data.fld_sequence,
                                                    cuttingCost: data.fld_cutting_cost,
                                                    cuttingCostBasePrice: data?.fld_cutting_base_price
                                                  })
                                                  if (data.fld_image != null) {

                                                    this.setState({
                                                      imagePreviewUrl: data.fld_image,
                                                      outputFileName: 'NoChange',
                                                      ItemLogo: data.fld_image
                                                    })
                                                  }
                                                  else {
                                                    this.setState({
                                                      imagePreviewUrl: 'https://icons.iconarchive.com/icons/pelfusion/flat-folder/256/Upload-Folder-icon.png',

                                                    })
                                                  }
                                                  window.location.href = "#upload-card"

                                                }}
                                                // onClick={this.onSaveData.bind(this)}
                                                className="btn Bechofy-btn waves-effect waves-light btn-sm float-left"
                                                style={{ marginTop: "5px", color: "white" }}
                                              >
                                                <span className=""><img src={Editicon} alt="block user" className="btnicons" style={{ marginRight: '5px' }}></img> </span>

                                                Edit
                                              </a>
                                            </span>
                                            <span className="d-block">
                                              <a
                                                onClick={() => {
                                                  localStorage.setItem("ShapeNameForEdit", data.fld_shape_name)
                                                  window.location.href = `/stickersizemaster/${data.fld_id}`;
                                                }}
                                                // onClick={this.onSaveData.bind(this)}
                                                className="btn Bechofy-btn waves-effect waves-light btn-sm"
                                                style={{ marginTop: "5px", color: "white" }}
                                              >
                                                <span className=""><img src={Searchicon} alt="block user" className="btnicons" style={{ marginRight: '5px' }}></img> </span>

                                                Size
                                              </a>
                                            </span>


                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Col>
                                  ))}
                                </Row>
                              </CardBody>
                            </Card>
                            :
                            <p style={{ display: this.state.ViewProductList == false ? 'none' : 'block' }}>
                              No Data Found
                            </p>
                          }
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Card>

                {/* <WelcomeComp /> */}
              </Col>
            </Row>
            {/* </Card>

							</Col>
						</Row> */}
          </Container>
        </div >
      </React.Fragment >
    );
  }
}

export default StickerShapeMaster;
